import React from 'react';

import { useLocalizationContext } from '@order/Localization';

import type { AccountMenuVariant } from '../../AccountMenu.types';
import { AccountMenuPrimaryItem } from '../AccountMenuPrimaryItem';
import { AccountSection } from '../AccountSection';

export const AccountMenuSignOutItem = (props: AccountMenuSignOutProps) => {
  const { variant, isSigningOut, onSignOut } = props;

  const { t } = useLocalizationContext();

  return (
    <AccountSection variant={variant}>
      <AccountMenuPrimaryItem
        testID="account.sidebar-tab.sign-out"
        label={t('account.sidebar.sign-out')}
        iconName="IconLogout"
        disabled={isSigningOut}
        onPress={onSignOut}
      />
    </AccountSection>
  );
};

type AccountMenuSignOutProps = {
  readonly variant: AccountMenuVariant;
  readonly isSigningOut: boolean;
  readonly onSignOut: () => void;
};
